var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withRouter } from "react-router-dom";
import DataTree from '../../../components/UI/DataTree/DataTree';
import AppRoutes from '../../../config/appRoutes';
var CategoriesList = /** @class */ (function (_super) {
    __extends(CategoriesList, _super);
    function CategoriesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contextMenu = [
            {
                label: 'Продукти',
                icon: 'fa fa-pencil-square-o',
                command: function () {
                    _this.products();
                }
            },
            {
                label: 'Редактиране',
                icon: 'fa fa-pencil-square-o',
                command: function () {
                    _this.editCategory();
                }
            },
            {
                label: 'Изтриване',
                icon: 'fa fa-trash-o',
                command: function () {
                    _this.deleteCategory();
                }
            },
            {
                label: 'Скриване',
                icon: 'fa fa-eye-slash',
                command: function () {
                    _this.hideCategory();
                }
            }
        ];
        _this.contextMenuSelectedItem = null;
        _this.contextMenuItemSelected = function (id) {
            _this.contextMenuSelectedItem = id ? id : null;
        };
        _this.editCategory = function () {
            if (_this.contextMenuSelectedItem) {
                _this.props.history.push(AppRoutes.editCategory.path.replace(':categoryId', _this.contextMenuSelectedItem));
            }
        };
        _this.products = function () {
            if (_this.contextMenuSelectedItem) {
                _this.props.history.push(AppRoutes.categoryProducts.path.replace(':id', _this.contextMenuSelectedItem));
            }
        };
        _this.deleteCategory = function () {
            _this.props.delete(_this.contextMenuSelectedItem);
        };
        _this.hideCategory = function () {
            _this.props.hide(_this.contextMenuSelectedItem);
        };
        return _this;
    }
    CategoriesList.prototype.render = function () {
        var data = this.props.data;
        return (React.createElement(DataTree, { data: data, contextMenu: this.contextMenu, onContexMenutItem: this.contextMenuItemSelected }));
    };
    return CategoriesList;
}(React.Component));
// @ts-ignore
export default withRouter(CategoriesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Categories/CategoriesList/CategoriesList.tsx
// module id = 323
// module chunks = 0